import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import DataCell from './DataCell';
import HeaderDataCell from './HeaderDataCell';
import Row from './server/elements/Row';
import { useColumns } from './utils/TableStore';
function DataRow(t0) {
  const $ = _c(11);
  const {
    rowId,
    pivot,
    index
  } = t0;
  const columns = useColumns();
  const firstRow = pivot && !index;
  let t1;
  if ($[0] !== columns || $[1] !== firstRow || $[2] !== pivot || $[3] !== rowId) {
    let t2;
    if ($[5] !== firstRow || $[6] !== pivot || $[7] !== rowId) {
      t2 = (column, colIndex) => {
        const field = pivot ? rowId : column;
        const dataId = pivot ? column : rowId;
        if (pivot && !colIndex) {
          return <HeaderDataCell key={dataId} field={field} firstRow={firstRow} colIndex={colIndex} fixed={true} />;
        }
        return <DataCell dataId={dataId} field={field} firstRow={firstRow} key={column} colIndex={colIndex} />;
      };
      $[5] = firstRow;
      $[6] = pivot;
      $[7] = rowId;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = columns.map(t2);
    $[0] = columns;
    $[1] = firstRow;
    $[2] = pivot;
    $[3] = rowId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <Row>{t1}</Row>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
export default memo(DataRow);